import axios from 'axios';

// 使用相对路径，通过Nginx代理访问后端API
const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || '';

// 创建axios实例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// 请求拦截器 - 添加认证token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 统一错误处理
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 面试评估API服务
 */
export class InterviewEvaluationAPI {
  
  /**
   * 提交面试评估请求
   * @param {Object} evaluationData - 评估数据
   * @param {string} evaluationData.resume_text - 简历内容
   * @param {string} evaluationData.job_title - 职位名称
   * @param {string} evaluationData.company_name - 公司名称
   * @param {Array} evaluationData.interview_questions - 面试题目列表
   * @param {string} evaluationData.interview_record - 面试对话记录
   * @returns {Promise<Object>} 评估结果
   */
  static async evaluateInterview(evaluationData) {
    try {
      const response = await api.post('/api/v1/interview/evaluate', evaluationData);
      
      return {
        success: true,
        data: response.data
      };
      
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || error.message || '评估服务异常',
        data: null
      };
    }
  }

  /**
   * 格式化评估结果用于显示
   * @param {Object} evaluationResult - 评估结果
   * @returns {Object} 格式化后的结果
   */
  static formatEvaluationResult(evaluationResult) {
    if (!evaluationResult || !evaluationResult.success) {
      return {
        score: 0,
        level: '需提升',
        overall_evaluation: '评估失败',
        strengths: [],
        weaknesses: ['评估服务异常'],
        recommendations: ['请稍后重试']
      };
    }

    const data = evaluationResult.data;
    
    return {
      score: data.score || 0,
      level: data.level || '需提升',
      overall_evaluation: data.overall_evaluation || '评估结果解析失败',
      strengths: data.strengths || [],
      weaknesses: data.weaknesses || [],
      recommendations: data.recommendations || []
    };
  }

  /**
   * 获取等级对应的颜色
   * @param {string} level - 等级
   * @returns {string} 颜色代码
   */
  static getLevelColor(level) {
    const colorMap = {
      '优秀': '#52c41a',
      '良好': '#1890ff',
      '一般': '#faad14',
      '需提升': '#f5222d'
    };
    return colorMap[level] || '#666666';
  }

  /**
   * 获取等级对应的图标
   * @param {string} level - 等级
   * @returns {string} 图标名称
   */
  static getLevelIcon(level) {
    const iconMap = {
      '优秀': 'star',
      '良好': 'thumbs-up',
      '一般': 'minus',
      '需提升': 'alert-triangle'
    };
    return iconMap[level] || 'help-circle';
  }
}

export default InterviewEvaluationAPI; 